/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_Q2Inputs */

const en_pc_alt_faq_q2 = /** @type {(inputs: Pc_Alt_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a PdfCraft alternative for editing existing text?`)
};

const zh_pc_alt_faq_q2 = /** @type {(inputs: Pc_Alt_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有没有能编辑 PDF 已有文字的 PdfCraft 替代品？`)
};

/**
* | output |
* | --- |
* | "Is there a PdfCraft alternative for editing existing text?" |
*
* @param {Pc_Alt_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_q2 = /** @type {((inputs?: Pc_Alt_Faq_Q2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_Q2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_q2(inputs)
	return zh_pc_alt_faq_q2(inputs)
});
export { pc_alt_faq_q2 as "pc.alt.faq.q2" }